import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
  root: {
    display: "flex",
    padding: 30,
    flexDirection: "column",
  },
  titleBox: {
    display: "flex",
    marginBottom: 10,
  },
}));
